const map = {
	"./m01.png": 6141,
	"./m02.png": 8726,
	"./m03.png": 7471,
	"./m04.png": 1600,
	"./m05.png": 7353,
	"./m06.png": 3346,
	"./m07.png": 7003,
	"./m08.png": 6700,
	"./m09.png": 4213,
	"./m10.png": 7855,
	"./m11.png": 4054,
	"./m12.png": 5821
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3671;